import { createContext } from 'react';
export const CoreConfigContext = createContext(undefined);
CoreConfigContext.displayName = 'CoreConfigProvider';
export const CoreConfigProvider = CoreConfigContext.Provider;
